import React from 'react'

const SunIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='12'
    height='12'
    viewBox='0 0 12 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M5.5 2.5V0.5H6.5V2.5H5.5ZM8.825 3.875L8.1375 3.1875L9.5375 1.75L10.2375 2.4625L8.825 3.875ZM9.5 6.5V5.5H11.5V6.5H9.5ZM5.5 11.5V9.5H6.5V11.5H5.5ZM3.175 3.85L1.75 2.4625L2.4625 1.7625L3.875 3.175L3.175 3.85ZM9.525 10.25L8.1375 8.8125L8.8125 8.1375L10.2375 9.5125L9.525 10.25ZM0.5 6.5V5.5H2.5V6.5H0.5ZM2.4625 10.25L1.7625 9.5375L3.1625 8.1375L3.525 8.475L3.8875 8.825L2.4625 10.25ZM6 9C5.16667 9 4.45833 8.70833 3.875 8.125C3.29167 7.54167 3 6.83333 3 6C3 5.16667 3.29167 4.45833 3.875 3.875C4.45833 3.29167 5.16667 3 6 3C6.83333 3 7.54167 3.29167 8.125 3.875C8.70833 4.45833 9 5.16667 9 6C9 6.83333 8.70833 7.54167 8.125 8.125C7.54167 8.70833 6.83333 9 6 9ZM6 8C6.55 8 7.02083 7.80417 7.4125 7.4125C7.80417 7.02083 8 6.55 8 6C8 5.45 7.80417 4.97917 7.4125 4.5875C7.02083 4.19583 6.55 4 6 4C5.45 4 4.97917 4.19583 4.5875 4.5875C4.19583 4.97917 4 5.45 4 6C4 6.55 4.19583 7.02083 4.5875 7.4125C4.97917 7.80417 5.45 8 6 8Z'
      fill='currentColor'
    />
  </svg>
)

export default SunIcon
